import type { JSX } from 'react';

import { Avatar } from '@change/ds-core-ui';

import asset from 'src/assets/advocates/changeUser.webp';

import type { AdvocateAvatarProps } from '../../types';
import { HAS_ADVOCATES_STATE } from '../../util';

export function AdvocateAvatar({ hasAdvocatesState, petitionAdvocates }: AdvocateAvatarProps): JSX.Element | null {
	if (hasAdvocatesState === HAS_ADVOCATES_STATE.none) {
		return <Avatar alt="avatar of the starter" size="large" src={asset} />;
	}

	// If there is one advocate, and the first advocate exists, render the avatar
	if (hasAdvocatesState === HAS_ADVOCATES_STATE.one && petitionAdvocates?.[0]) {
		const advocate = petitionAdvocates[0];
		return (
			<Avatar
				size="large"
				src={advocate.photo?.userSmall.url}
				initial={!advocate.photo?.userSmall.url ? advocate.firstName.charAt(0) : undefined}
				alt={`avatar of ${advocate.firstName} ${advocate.lastInitial}`}
			/>
		);
	}

	// If there are multiple advocates, render the avatar
	if (hasAdvocatesState === HAS_ADVOCATES_STATE.multiple && petitionAdvocates) {
		return (
			<div className="flex items-center [&>*:not(:first-child)]:-ml-3">
				{petitionAdvocates.slice(0, 4).map((advocate) => {
					if (!advocate) return null;
					return (
						<Avatar
							key={advocate.id}
							size="medium"
							src={advocate.photo?.userSmall.url}
							initial={!advocate.photo?.userSmall.url ? advocate.firstName.charAt(0) : undefined}
							alt={`avatar of ${advocate.firstName} ${advocate.lastInitial}`}
							className="flex-shrink-0 border border-stroke-inverse-strong"
						/>
					);
				})}
			</div>
		);
	}

	return null;
}
